import letrusAPI from 'APIs/letrusAPI/axiosInstance';

export const fetchAblyWebSocketAuthToken = (composition_id?: string) =>
  letrusAPI(`/api/v1/auth/websocket-token/`, {
    method: 'get',
    params: {
      composition_id,
    },
  });
